import { Dictionary, IStringDateRange2, Group, IValueViewModel } from '../../models';
import { IWidget } from 'widgets';
import { specialWidgetTypes } from '../group/validation/validation.constants';
import { IDashboardLoadService, IRelativeGroupHelperService } from '../../services';

export interface IValidationStandAloneService {
    getGroupGuids(widgetList: IWidget[], dates: IStringDateRange2, group: Group, groupsDictionary: Dictionary<Group>, viewModelsDictionary: Dictionary<IValueViewModel>, referenceGroup?: string): angular.IPromise<string[]>;
}

export class ValidationStandAloneService implements IValidationStandAloneService {
    static serviceId = 'validationStandAloneService';
    static $inject = [
        'relativeGroupHelperService',
        'dashboardLoadService',
    ];

    constructor(
        private _relativeGroupHelperService: IRelativeGroupHelperService,
        private _dls: IDashboardLoadService
    ) {
    }

    getGroupGuids(widgetList: IWidget[], dates: IStringDateRange2, group: Group, groupsDictionary: Dictionary<Group>, viewModelsDictionary: Dictionary<IValueViewModel>, referenceGroup?: string) {
        return this._dls.buildConfigurations(widgetList, dates.beginDate, dates.endDate, group.guid)
            .then(data => {
                try {
                    const specialWidgets = widgetList.filter(w => specialWidgetTypes.includes(w.type))
                        .map(w => this._relativeGroupHelperService.getGroup(Object.assign({}, w.configuration as any, { referenceGroup: w.configuration.referenceGroup || referenceGroup || (w.configuration as any).group }), group, groupsDictionary).guid);
                    const seriesGuids = data.widgetConfiguration.flatMap(d => d.configuration.series.map(s => s.guid));
                    const currentGuids = [group.guid].concat(
                        seriesGuids.flatMap(s => viewModelsDictionary[s]?.groupList?.map(g => g.guid) ?? []))
                        .concat(data.groupStatesRequest?.flatMap(d => d.guidList) || [])
                        .concat(specialWidgets)
                        //Filter unique values
                        .filter((value, index, array) => {
                            return array.indexOf(value) === index;
                        });
                    return currentGuids;
                }
                catch (e) {
                    console.error(e);
                    return [];
                }
            });
    }

}